import React from 'react'

export const MotoboyContext = React.createContext({})